module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-promo/btn-spin@1x.png
// module id = 217
// module chunks = 0